'use strict'

export const SVG = {}
export const SVG_DATA = {}
